export default __webpack_public_path__ + "static/media/weight.41e6fa24.svg";